module.exports = __webpack_public_path__ + "img/upload.20a5b4bc.png";